import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './components/styles.css';
import './App.css';

//import express from 'express';
//const app = express();

// main-emnus
import NavBar from './components/pages/NavBar';
import MainContent from './components/pages/MainContent';
import Services from './components/pages/Services';
import About from './components/pages/About';
import Footer from './components/pages/Footer';
// sub-menus
import OurProgram from './components/pages/OurProgram';
import HowItWorks from './components/pages/HowItWorks';
import DigitalAgentTracking from './components/pages/DigitalAgentTracking';
import BenefitsForPartners from './components/pages/BenefitsForPartners';
import Overview from './components/pages/Overview';
import Corporate from './components/pages/Corporate';
import Partners from './components/pages/Partners';
import Trademarks from './components/pages/Trademarks';
import Privacy from './components/pages/Privacy';
import EmployeePortal from './components/pages/EmployeePortal';
import Unsubscribe from './components/pages/Unsubscribe';

function App() {

  
  return (

      <BrowserRouter future={{ v7_startTransition: true }}>

        <div className='container-main'>
          <div className='main-box-1'>
            <NavBar />
          </div>
          <div className='main-box-2'>
            
            <Routes>

              <Route path="/" exact element={<MainContent />} />
              <Route path="/services" element={<Services />} />
              <Route path='/about' element={<About />} />
              <Route path='/our-program' element={<OurProgram />} />
              <Route path='/how-it-works' element={<HowItWorks />} />
              <Route path='/digital-agent-tracking' element={<DigitalAgentTracking />} />
              <Route path='/benefits-for-partners' element={<BenefitsForPartners />} />
              <Route path='/overview' element={<Overview />} />
              <Route path='/corporate' element={<Corporate />} />
              <Route path='/partners' element={<Partners />} />
              <Route path='/trademarks' element={<Trademarks />} />
              <Route path='/privacy' element={<Privacy />} />
              <Route path='/employee-portal' element={<EmployeePortal />} />
              <Route path='/unsubscribe' element={<Unsubscribe />} />
              <Route path='*' element={<MainContent />}/>

            </Routes>
            
          </div>
          <div className='main-box-3'>
            <Footer />
          </div>
        </div>

      </BrowserRouter>


  );

}

export default App;
